export const SET_INITIAL_STATE = "SET_INITIAL_STATE";
export const SET_PAGE_SIZE_GLOBAL = " SET_PAGE_SIZE_GLOBAL"

//-------------------------------RETURN_APPROVALS-LIST------------------------------------------
export const SET_RETURN_APPROVALS_PENDING = "SET_RETURN_APPROVALS_PENDING";
export const SET_RETURN_APPROVALS_LIST = "SET_RETURN_APPROVALS_LIST";
export const SET_RETURN_APPROVALS_LIST_COUNT = " SET_RETURN_APPROVALS_LIST_COUNT"
export const RETURN_APPROVALS_LIST_ERROR = " RETURN_APPROVALS_LIST_ERROR"
export const RETURN_APPROVALS_LIST_COUNT_ERROR = " RETURN_APPROVALS_LIST_COUNT_ERROR"

//-------------------------------RETURN_APPROVALS-ACTIONS---------------------------------------
export const SET_ACTION = "SET_ACTION";
export const SET_SELECTED_REQUEST_ID = "SET_SELECTED_REQUEST_ID";
export const OPEN_RETURN_APPROVALS_ACTION_MODAL = "OPEN_RETURN_APPROVALS_ACTION_MODAL";
export const CLOSE_RETURN_APPROVALS_ACTION_MODAL = "CLOSE_RETURN_APPROVALS_ACTION_MODAL";
export const SET_RETURN_APPROVALS_FORM = " SET_RETURN_APPROVALS_FORM"
export const SUBMIT_RETURN_APPROVALS_ACTION_PENDING = "SUBMIT_RETURN_APPROVALS_ACTION_PENDING";
export const SUBMIT_RETURN_APPROVALS_ACTION_SUCCESS = "SUBMIT_RETURN_APPROVALS_ACTION_SUCCESS";
export const SUBMIT_RETURN_APPROVALS_ACTION_ERROR = "SUBMIT_RETURN_APPROVALS_ACTION_ERROR";
export const CLEAR_SUBMIT_RETURN_APPROVALS_ACTION_ERROR = "CLEAR_SUBMIT_RETURN_APPROVALS_ACTION_ERROR";
